import { NgModule } from '@angular/core';
import { LibDownloadSmallIconComponent } from './lib-download-small-icon.component';

@NgModule({
  declarations: [LibDownloadSmallIconComponent],
  exports: [LibDownloadSmallIconComponent],
})
export class LibDownloadSmallIconModule {}
